/**
 * Single source of truth for the brand phone + email.
 * Update once here and it propagates across every CTA.
 */
export const PHONE_DISPLAY = "+61 430 472 144";
export const PHONE_HREF = "tel:+61430472144";

export const EMAIL_DISPLAY = "info.nector@gmail.com";
export const EMAIL_HREF = "mailto:info.nector@gmail.com";

/**
 * Fires Google Ads click-to-call conversion (AW-17895994697/2ngDCJ_e078cEMnqvNVC).
 * Attach to any phone link's onClick. The native tel: action proceeds normally —
 * we only fire the analytics ping, we don't preventDefault.
 */
export function trackPhoneCall() {
  if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
    try { window.gtag_report_conversion(); } catch (e) { /* swallow */ }
  }
}
